import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { tap, map, withLatestFrom } from 'rxjs/operators';
import { createEffect, Actions, ofType } from '@ngrx/effects';

import { RouterActionTypes, RouterNavigate, RouterNavigateByUrl } from '../actions';
import * as overviewStore from '@overviewstore/*';
import * as appStore from '@appstore/*';
import { Store } from '@ngrx/store';
import { getRouterState } from '../registration';

@Injectable()
export class RouterEffects {
    constructor(
        private actions$: Actions,
        private router: Router,
        private location: Location,
        private store: Store<overviewStore.OverviewState | appStore.AppState>
    ) {
    }


    navigate$ = createEffect(() => this.actions$.pipe(
        ofType(RouterActionTypes.ROUTER_NAVIGATE),
        map((action: RouterNavigate) => action.payload),
        tap(({ path, query: queryParams, extras }) => {
            this.router.navigate(path, { queryParams, ...extras });
        })
    ), { dispatch: false });


    navigateByUrl$ = createEffect(() => this.actions$.pipe(
        ofType(RouterActionTypes.ROUTER_NAVIGATE_BY_URL),
        map((action: RouterNavigateByUrl) => action.payload),
        tap(path => this.router.navigateByUrl(path))
    ), { dispatch: false });


    navigateBack$ = createEffect(() => this.actions$.pipe(
        ofType(RouterActionTypes.ROUTER_BACK),
        tap(() => this.location.back())
    ), { dispatch: false });


    navigateForward$ = createEffect(() => this.actions$.pipe(
        ofType(RouterActionTypes.ROUTER_FORWARD),
        tap(() => this.location.forward())
    ), { dispatch: false });


    navigateToTourStop$ = createEffect(() => this.actions$.pipe(
        ofType(RouterActionTypes.ROUTER_NAVIGATE_T0_TOUR_STOP),
        withLatestFrom(this.store.select(getRouterState)),
        map(([action, route]) => route.state.params),
        tap((params) => {
            if (params.actionId) {
                this.location.back();
            }
        })
    ), { dispatch: false });

    // INFO: This is used after protocol submit
    // we want to navigate to tour stop detail coming from protocol page
    // TODO: This might not needed anymore after fixing the "back" button functionality

    navigateToTourStopDetail$ = createEffect(() => this.actions$.pipe(
        ofType(RouterActionTypes.ROUTER_NAVIGATE_T0_TOUR_STOP_DETAIL),
        tap(() => window.history.go(-2) )
    ), { dispatch: false });

}
